// src/router/config.ts
const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/scene/:uuid",
    exact: true,
    component: "CaptureView",
  },
  // Stories/Blog routes
  {
    path: "/stories",
    exact: true,
    component: "Stories",
  },
  {
    path: "/stories/:slug",
    exact: true,
    component: "StoryDetail",
  },
  // Legal document routes - single dynamic route for all documents
  {
    path: [
      "/privacy-CN",
      "/privacy-EN", 
      "/Terms-And-Conditions-CN",
      "/Terms-And-Conditions-EN",
      "/User-Content-License-Agreement-CN",
      "/User-Content-License-Agreement-EN"
    ],
    exact: true,
    component: "LegalDocument",
  },
  // Splat Viewer
  {
    path: "/viewer",
    exact: true,
    component: "SplatViewer",
  },
  // 404 catch-all route (must be last)
  {
    path: "*",
    exact: false,
    component: "NotFound",
  },
];

export default routes;
